module.exports = __webpack_public_path__ + "static/media/632100D4778F2AD0.d96e2920.png";